import short from 'short-uuid';

export function generateId() {
	return short.generate();
}
